import * as React from 'react';
import { st, classes } from './Avatar.base.st.css';
import { AnonymousIcon } from './AnonymousIcon';
import { nameToInitials } from './utils';
import { WowImage } from '../WowImage';
import { ImageResizeOptions } from '../Image';
var DEFAULT_CONTENT_TYPE = 'placeholder';
export function AvatarBase(props) {
    var name = props.name, src = props.src, onLoad = props.onLoad, className = props.className;
    var _a = React.useState(false), imgLoaded = _a[0], setImgLoaded = _a[1];
    var _b = React.useState(function () {
        return name ? 'text' : DEFAULT_CONTENT_TYPE;
    }), contentType = _b[0], setContentType = _b[1];
    React.useEffect(function () {
        setContentType(name ? 'text' : DEFAULT_CONTENT_TYPE);
        setImgLoaded(false);
        if (src) {
            var image_1 = new Image();
            image_1.onload = function () {
                image_1 && setContentType('image');
                image_1 && setImgLoaded(true);
            };
            image_1.src = src;
        }
    }, [src]);
    function getContent(type) {
        switch (type) {
            case 'text': {
                return (React.createElement("div", { className: classes.content, "data-hook": "text-container" }, nameToInitials(name)));
            }
            case 'placeholder': {
                return (React.createElement(AnonymousIcon, { className: st(classes.content, classes.anonymous) }));
            }
            case 'image': {
                return (React.createElement(WowImage, { className: st(classes.content, classes.image), alt: name, src: src, onLoad: onLoad, resize: ImageResizeOptions.cover, fluid: true }));
            }
            default: {
                return null;
            }
        }
    }
    return (React.createElement("div", { "data-content-type": contentType, "data-img-loaded": imgLoaded, "data-hook": props['data-hook'], title: name, "aria-label": name, className: st(classes.root, className) }, getContent(contentType)));
}
//# sourceMappingURL=Avatar.base.js.map